import { API } from "."
import {
  CreateSessionCropDataPayload,
  CreateSessionDataParams,
  CreateSessionDataPayload,
  CreateSessionDataResponse,
  CreateSessionPayload,
  DeleteSessionCropParams,
  DeleteSessionDataParams,
  DeleteSessionDataPayload,
  DeleteSessionDataResponse,
  ReadSessionDataItemsResponse,
  ReadSessionResponse,
  ReadSessionTypeStatsResponse,
  SessionRotationPayload,
  UpsertSessionPayload,
  UpsertSessionTimePayload,
  UpsertSessionTimeResponse,
} from "@/types/session"

/* 호출 시 /teams/{idfTeam} 붙음 */

/* 세션 정보 조회 */
export async function readSession(idfSession: number) {
  return await API.get<ReadSessionResponse>(`/sessions/${idfSession}`)
}

/* 세션 생성 — 응답은 생성된 세션의 idfSession */
export async function createSession(payload: CreateSessionPayload) {
  const { autoMatch, ...body } = payload
  const params = autoMatch === false ? { autoMatch: false } : undefined

  return await API.post<number>("/sessions", body, { params })
}

/* 세션 수정 */
export async function upsertSession(data: { idfSession: number; payload: UpsertSessionPayload }) {
  const { idfSession, payload } = data

  return await API.put<void>(`/sessions/${idfSession}`, payload)
}

/* 세션 삭제 */
export async function deleteSession(idfSession: number) {
  return await API.delete<void>(`/sessions/${idfSession}`)
}

/* 팀 세션 타입별 개수 조회 */
/**
 * @param {number|string|Array} idfTeam [Required]
 */
export async function readSessionTypeStats() {
  return await API.get<ReadSessionTypeStatsResponse>("/sessions/type-stats")
}

/* 세션 데이터 목록 조회 */
export async function readSessionDataItems(idfSession: number) {
  return await API.get<ReadSessionDataItemsResponse>(`/sessions/${idfSession}/data`)
}

/* 세션 데이터 추가, 수정 */
export async function createSessionData(data: {
  params: CreateSessionDataParams
  payload: CreateSessionDataPayload
}) {
  const { params, payload } = data
  const { idfSession, idfData } = params

  return await API.post<CreateSessionDataResponse>(
    `/sessions/${idfSession}/data/${idfData}`,
    payload,
  )
}

/* 세션 데이터 일괄 등록 */
export async function createSessionDataBulk(
  idfSession: number,
  payload: CreateSessionDataPayload[],
) {
  return await API.post<void>(`/sessions/${idfSession}/data`, payload)
}

/* 세션 데이터 삭제 */
export async function deleteSessionData(data: {
  params: DeleteSessionDataParams
  payload: DeleteSessionDataPayload
}) {
  const { params, payload } = data
  const { idfSession, idfData } = params

  return await API.delete<DeleteSessionDataResponse>(`/sessions/${idfSession}/data/${idfData}`, {
    data: payload,
  })
}

/* 세션 시간 수정 */
export async function upsertSessionTime(data: {
  idfSession: number
  payload: UpsertSessionTimePayload
}) {
  const { idfSession, payload } = data

  return await API.put<UpsertSessionTimeResponse>(`/sessions/${idfSession}/time`, payload)
}

/* 세션 참여 시간 제외 */
export async function createSessionCrop(data: {
  idfSession: number
  payload: CreateSessionCropDataPayload
}) {
  const { idfSession, payload } = data

  return await API.post<void>(`/sessions/${idfSession}/crop`, payload)
}

/* 세션 참여 시간 제외 제거 */
export async function deleteSessionCrop(params: DeleteSessionCropParams) {
  const { idfSession, idfSessionCropRecord } = params

  return await API.delete<void>(`/sessions/${idfSession}/crop/${idfSessionCropRecord}`)
}

/* 세션 로테이션 적용 */
export async function updateSessionRotation(payload: SessionRotationPayload) {
  return await API.put<void>("/sessions/rotation", payload)
}
